import { BREAK, type DocumentNode, Kind, OperationTypeNode, visit } from "graphql";

// Fence-aware documents are recognized by SHAPE on both sides of the
// fence: a mutation that SELECTS `writeToken` can mint, and a query that
// DECLARES `$atLeast` presents. These predicates are what let the links
// pass every other operation through untouched. Memoized per document
// node — documents are module singletons — so the per-operation cost
// after warmup is one WeakMap hit.

const mintingDocuments = new WeakMap<DocumentNode, boolean>();

export const selectsWriteToken = (document: DocumentNode): boolean => {
  const known = mintingDocuments.get(document);
  if (known !== undefined) {
    return known;
  }
  let selects = false;
  visit(document, {
    Field(node) {
      if (node.name.value === "writeToken") {
        selects = true;
        return BREAK;
      }
    },
  });
  mintingDocuments.set(document, selects);
  return selects;
};

const fenceAwareDocuments = new WeakMap<DocumentNode, boolean>();

export const declaresAtLeast = (document: DocumentNode): boolean => {
  const known = fenceAwareDocuments.get(document);
  if (known !== undefined) {
    return known;
  }
  const declares = document.definitions.some(
    (definition) =>
      definition.kind === Kind.OPERATION_DEFINITION &&
      definition.operation === OperationTypeNode.QUERY &&
      (definition.variableDefinitions ?? []).some(
        ({ variable }) => variable.name.value === "atLeast",
      ),
  );
  fenceAwareDocuments.set(document, declares);
  return declares;
};
